var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgProfile = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 25 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12.372 4.464a4.535 4.535 0 0 0-4.538 4.538 4.535 4.535 0 0 0 4.538 4.537 4.535 4.535 0 0 0 4.537-4.537 4.535 4.535 0 0 0-4.537-4.538Zm0 1.553a2.99 2.99 0 0 1 2.985 2.985 2.99 2.99 0 0 1-2.985 2.985 2.99 2.99 0 0 1-2.985-2.985 2.99 2.99 0 0 1 2.985-2.985Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12.378 0c-6.626 0-12 5.373-12 12s5.374 12 12 12c6.627 0 12-5.373 12-12s-5.373-12-12-12Zm0 1.552c5.758 0 10.448 4.683 10.448 10.448 0 3.496-1.723 6.595-4.365 8.492v-5.44H6.282v5.43A10.438 10.438 0 0 1 1.931 12c0-5.765 4.683-10.448 10.447-10.448ZM7.834 21.408a10.393 10.393 0 0 0 4.544 1.04c1.623 0 3.16-.371 4.531-1.033v-4.811H7.834v4.804Z",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgProfile);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Profile.2b3f2ed3a90f2f267628e81331d21338.svg";